import geometry from '../../../../scene/util/geometry';
import { unique } from '../../../../util/array';
import { isType } from '../../../../services/products';
import tacHelpers from '../../tacHelpers';
import { mergePolygons } from '../../../../util/mergePolygons';
import { ITEMS } from '../../../../constants';

function digSuperSection(tac, member, skiplist) {
  // pad items just a little so they overlap a bit with stuff they touch
  const padding = {
    right: 4,
    left: 4,
    front: 10,
    back: 10,
  };

  const superSection = [member];

  const candidates = tac.items.filter(
    item =>
      item.itemid !== member.itemid && skiplist.indexOf(item.itemid) === -1
  );

  const collisions = candidates.filter(candidate =>
    geometry.collides(member, candidate, padding)
  );
  let skip = skiplist
    .concat(collisions.map(item => item.itemid))
    .concat(superSection.map(item => item.itemid))
    .filter(unique);

  const rest = [];
  collisions.forEach(collision => {
    const dug = digSuperSection(tac, collision, skip);
    Array.prototype.push.apply(rest, dug.items);
    skip = skip.concat(dug.skip).filter(unique);
  });

  return {
    skip,
    items: Array.prototype.concat.apply(superSection, rest).filter(unique),
  };
}

function findSuperSection(tac, member, skiplist) {
  return digSuperSection(tac, member, skiplist).items;
}

function isSuperSectionHandle(item) {
  return isType(item, ITEMS.SECTION);
}

function getSuperSectionSpace(tac, superSection) {
  const wallPoly = {
    regions: [tac.wall.points.map(coords => [coords.x, coords.y])],
    inverted: true,
  };

  const ssItemIds = tacHelpers
    .getAllItems(superSection)
    .map(item => item.itemid);
  const rest = tacHelpers.filterTac(tac, ssItemIds);
  if (!rest.items.length) {
    //supersection is alone on scene
    return wallPoly;
  }

  const rects = tacHelpers.getRects(rest, null, tac, false);
  const withHeight = rects.map(rect => ({
    ...rect,
    height: rect.height || tacHelpers.getItem(tac, rect.itemid).height,
  }));
  const itemsPoly = geometry.rects2poly(withHeight);

  return mergePolygons(itemsPoly, wallPoly);
}

export default {
  findSuperSection,
  isSuperSectionHandle,
  getSuperSectionSpace,
};
